/* ------------------------------------------------------
Article Navigation Class
------------------------------------------------------ */

class ArticleNavigationController extends Classy {
  constructor(nav) {
    super();
    // The nav element
    this.nav = nav;
    // The nav's parent
    this.parent = nav.parentNode;
    // The nav's siblings
    this.siblings = [...this.parent.children].filter(child => child !== this.nav);
    // A list of anchors
    this.anchors = [];
    // A mutation observer to check for new anchors inside the parent
    this.observer = new MutationObserver(() => this.update());

    // Observe the parent for changes
    this.observer.observe(this.parent, {
      childList: true
    });
  }
  update() {
    // Loop all the anchors in the parent
    [...this.parent.querySelectorAll('a[id]:not([href])')].forEach(anchor => {
      // If the anchor is already in the list, return
      if (this.anchors.includes(anchor)) return;

      // Add the anchor to the list
      this.anchors.push(anchor);
    });

    // Loop through the anchors
    this.anchors.forEach(anchor => {
      // If the anchor is not in the parent anymore, remove it
      if (!this.parent.contains(anchor)) {
        // Remove the anchor from the list
        this.anchors.splice(this.anchors.indexOf(anchor), 1);
      }
    });

    // The update callback
    this.callback('update', this.anchors);
  }
  init() {
    // Update the anchors
    this.update();

    // The init callback
    this.callback('init');
  }
}

/* ------------------------------------------------------
Constants
------------------------------------------------------ */

// Find the navigation elements
const navs = [...document.querySelectorAll('.js-article-navigation')];

/* ------------------------------------------------------
Page setup
------------------------------------------------------ */

// Loop through the navigation elements
navs.forEach(nav => {
  // Create a new ArticleNavigationController
  const ArticleNavigation = new ArticleNavigationController(nav);
  // Each nav has a list
  const list = nav.querySelector('.js-article-navigation__list');
  console.log(nav);
  ArticleNavigation.on('update', anchors => {
    console.log(anchors);
    // Empty the list
    list.innerHTML = '';

    // If the anchors are empty, return and add a hide class to the nav
    nav.classList.toggle('hidden', !anchors.length);
    if (!anchors.length) return;

    // Loop through the anchors
    anchors.forEach(anchor => {
      // Grab the heading's ID
      const id = anchor.id;
      // Grab the anchor's text
      const text = anchor.parentNode.innerText;
      // Create a new list item <li>
      const item = document.createElement('li');
      // Create a new link <a>
      const link = document.createElement('a');

      // Set the link href
      link.href = `#${id}`;
      // Set the link text
      link.innerText = text;

      // Append the link to the item
      item.appendChild(link);

      // Append the item to the list
      list.appendChild(item);

      // Add a click event to the link
      link.addEventListener('click', e => {
        e.preventDefault();
        // Scroll to the anchor
        window.ScrollController.scrollTo(Meteora.offset(anchor).y - 200, 500);
      });
    });
  });

  // Initialize the ArticleNavigationController
  ArticleNavigation.init();
});